exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vertical-sub-tabs-layout[data-v-0927999c] {\n  display: flex;\n  gap: 16px;\n}\n.vertical-sub-tabs-layout .tabs[data-v-0927999c] {\n  max-width: 220px;\n  flex-shrink: 1;\n  flex-grow: 0;\n  width: 100%;\n}\n.vertical-sub-tabs-layout .content[data-v-0927999c] {\n  flex-grow: 1;\n  flex-shrink: 1;\n}", ""]);

// exports
